module.exports = __webpack_public_path__ + "img/Reposteria.d052c05c.png";